import {
  withTranslation,
} from 'react-i18next';

import EntryUnmatchedFieldsView from './EntryUnmatchedFieldsView';

const TranslatedComponent = withTranslation()(EntryUnmatchedFieldsView);

const Component = TranslatedComponent;

export default Component;
